import React, { useCallback, useEffect, useState } from "react";

import { Box, Grid, Tab, Tabs } from "@mui/material";
import "./TemplateList.css";
import TemplateListModal from "./TemplateListModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getAllTemplate, getSpeacialityTemplates } from "../../api/template";
import AdvisoryTemplateMaster from "./Advisory/AdvisoryTemplateMaster";

export const TEMPLATE_TABS = {
  PRESCRIPTION: "prescription",
  ADVISORY: "advisory",
};

const TemplateList = () => {
  const [open, setOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [minortemplates, setMinorTemplates] = useState([]);
  const [id, setId] = useState("");
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // ?tab=advisory opens the Advisory Templates tab; ?edit=<id> on it opens
  // that advisory for editing (the speciality cards' list links here).
  const tab =
    searchParams.get("tab") === TEMPLATE_TABS.ADVISORY
      ? TEMPLATE_TABS.ADVISORY
      : TEMPLATE_TABS.PRESCRIPTION;
  const editAdvisoryId = tab === TEMPLATE_TABS.ADVISORY ? searchParams.get("edit") || "" : "";

  async function getSpeacialityList() {
    const response = await getAllTemplate();
    if (response?.status === 200) {
      setTemplates(response.data.data);
    } else {
      console.log("Error fetching speciality");
    }
  }

  async function getSpeacialityTemplatesByID(id) {
    if (!id) return;
    const response = await getSpeacialityTemplates(id);
    if (response?.status === 200) {
      setMinorTemplates(response.data.data?.templates);
    } else {
      console.log("Error fetching speciality");
    }
  }

  useEffect(() => {
    getSpeacialityList();
  }, []);
  useEffect(() => {
    getSpeacialityTemplatesByID(id);
  }, [id]);

  const selectTab = (next) => {
    setSearchParams(next === TEMPLATE_TABS.ADVISORY ? { tab: next } : {});
  };

  const openAdvisoryEditor = (advisoryId) => {
    setOpen(false);
    setSearchParams({ tab: TEMPLATE_TABS.ADVISORY, edit: advisoryId });
  };

  const clearAdvisoryEdit = useCallback(() => {
    setSearchParams({ tab: TEMPLATE_TABS.ADVISORY });
  }, [setSearchParams]);

  return (
    <Box padding={2}>
      <div className="template_header">
        <h1>Admin Templates</h1>
        {tab === TEMPLATE_TABS.PRESCRIPTION && (
          <button onClick={() => navigate("/addtemplate")}>Add Template</button>
        )}
      </div>
      <Tabs
        value={tab}
        onChange={(event, next) => selectTab(next)}
        sx={{ mb: 2, borderBottom: "1px solid #ddd" }}
      >
        <Tab label="Prescription Templates" value={TEMPLATE_TABS.PRESCRIPTION} />
        <Tab label="Advisory Templates" value={TEMPLATE_TABS.ADVISORY} />
      </Tabs>

      {tab === TEMPLATE_TABS.ADVISORY ? (
        <AdvisoryTemplateMaster editId={editAdvisoryId} onEditHandled={clearAdvisoryEdit} />
      ) : (
        <>
          <TemplateListModal
            setOpen={setOpen}
            open={open}
            minortemplates={minortemplates}
            onEditAdvisory={openAdvisoryEditor}
            onChanged={() => {
              getSpeacialityTemplatesByID(id);
              getSpeacialityList();
            }}
          />
          <Grid container spacing={2}>
            {templates.map((item, index) => (
              <Grid item xs={4} key={index}>
                <div
                  className="category_card"
                  onClick={() => {
                    setId(item?.specialization?._id);
                    setOpen(true);
                  }}
                >
                  <h1>{item.specialization?.name}</h1>
                  <p>
                    <span>{item.count}</span> Templates
                  </p>
                </div>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Box>
  );
};

export default TemplateList;
